/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    ChannelIslandsError: {
        id: 'qnb.smi.error.ChannelIslandsError',
        defaultMessage: 'We are sorry that, as a result of your location, we are unable to offer you a quotation.'
    },
    DeclineErrorMessage: {
        id: 'qnb.smi.error.DeclineErrorMessage',
        defaultMessage: 'We are sorry that, as a result of some of the information you have provided, we are unable to offer you a quotation.'
    },
    ErrorHeader: {
        id: 'qnb.smi.error.ErrorHeader',
        defaultMessage: 'Thank you for visiting Saga…'
    },
    ErrorHeaderPayment: {
        id: 'qnb.smi.error.ErrorHeaderPayment',
        defaultMessage: 'Sorry there has been a problem in trying to take payment for your Saga Insurance'
    },
    ErrorHeaderRetrieve: {
        id: 'qnb.smi.error.ErrorHeaderRetrieve',
        defaultMessage: 'Thank you for your interest in Saga\'s Health Insurance'
    },
    WeAreSorryCannotRetrieveQuoteOnline: {
        id: 'qnb.smi.error.WeAreSorryCannotRetrieveQuoteOnline',
        defaultMessage: 'We are sorry but you cannot retrieve your quote online.'
    },
    PleaseGiveUsACallRetrieveQuoteOnline: {
        id: 'qnb.smi.error.PleaseGiveUsACallRetrieveQuoteOnline',
        defaultMessage: 'Please give us a call and one of our customer service advisers will be happy to help.'
    },
    OpeningHoursRetrieveQuoteOnline: {
        id: 'qnb.smi.error.OpeningHoursRetrieveQuoteOnline',
        defaultMessage: 'Our lines are open 8:30am to 7pm weekdays and 9am to 1pm Saturday.'
    },
    ExistingCustomerHeader: {
        id: 'qnb.smi.error.ExistingCustomerHeader',
        defaultMessage: 'Are you an existing customer?'
    },
    ExistingCustomerAnswer0: {
        id: 'qnb.smi.error.ExistingCustomerAnswer0',
        defaultMessage: 'Yes, I\'m thinking about renewing my policy'
    },
    ExistingCustomerAnswer0Content1: {
        id: 'qnb.smi.error.ExistingCustomerAnswer0Content1',
        defaultMessage: "We send renewal documents out at least 21 days before your renewal is due. If you'd like to talk to us about your renewal, we'll be happy to help - just "
    },
    ExistingCustomerAnswer0Content2: {
        id: 'qnb.smi.error.ExistingCustomerAnswer0Content2',
        defaultMessage: 'call us free on {phoneNumber}.'
    },
    ExistingCustomerAnswer0Content3: {
        id: 'qnb.smi.error.ExistingCustomerAnswer0Content3',
        defaultMessage: "<strong>Important: </strong>if you don't want to continue with your Saga policy, please let us know before your renewal date."
    },
    ExistingCustomerAnswer1: {
        id: 'qnb.smi.error.ExistingCustomerAnswer1',
        defaultMessage: 'Yes, I\'m thinking about making some changes to my policy'
    },
    ExistingCustomerAnswer1Content1: {
        id: 'qnb.smi.error.ExistingCustomerAnswer1Content1',
        defaultMessage: 'To find out more about making changes to your policy, please visit the policy details section of our website '
    },
    ExistingCustomerAnswer1Content2: {
        id: 'qnb.smi.error.ExistingCustomerAnswer1Content2',
        defaultMessage: 'Alternatively, if you would like to speak to one of our customer service advisers '
    },
    ExistingCustomerAnswer1Content3: {
        id: 'qnb.smi.error.ExistingCustomerAnswer1Content3',
        defaultMessage: 'call us free on {phoneNumber}'
    },
    ExistingCustomerAnswer2: {
        id: 'qnb.smi.error.ExistingCustomerAnswer2',
        defaultMessage: 'No, I am not currently insured with Saga'
    },
    ExistingCustomerAnswer2Content1: {
        id: 'qnb.smi.error.ExistingCustomerAnswer2Content1',
        defaultMessage: 'Don\'t worry - there are sometimes circumstances in which we can\'t provide a quote online, but can over the phone.'
    },
    ExistingCustomerAnswer2Content2: {
        id: 'qnb.smi.error.ExistingCustomerAnswer2Content2',
        defaultMessage: 'Please '
    },
    ExistingCustomerAnswer2Content3: {
        id: 'qnb.smi.error.ExistingCustomerAnswer2Content3',
        defaultMessage: 'call us free on {phoneNumber}'
    },
    ExistingCustomerAnswer2Content4: {
        id: 'qnb.smi.error.ExistingCustomerAnswer2Content4',
        defaultMessage: ' - we\'ll be happy to help.'
    },
    Here: {
        id: 'qnb.smi.error.Here',
        defaultMessage: 'here'
    },
    LinesOpen: {
        id: 'qnb.smi.error.LinesOpen',
        defaultMessage: 'Our lines are open 8.30am to 7pm weekdays, and 9.00am to 1pm Saturdays.'
    },
    NewQuote: {
        id: 'qnb.smi.error.NewQuote',
        defaultMessage: 'Begin a new quote'
    },
    NewQuote2: {
        id: 'qnb.smi.error.NewQuote2',
        defaultMessage: 'start a new quote'
    },
    PaymentCallUs: {
        id: 'qnb.smi.error.PaymentCallUsSmi',
        defaultMessage: 'Please call {phoneNumber} and speak to one of our agents who will be able to help.'
    },
    PleaseCallUs: {
        id: 'qnb.smi.error.PleaseCallUs',
        defaultMessage: 'Please give us a call on {phoneNumber} to continue with your request'
    },
    PurchaseNotComplete: {
        id: 'qnb.smi.error.PurchaseNotComplete',
        defaultMessage: 'We have not been able to complete your policy purchase.'
    },
    RetrieveTiaQuoteHeader: {
        id: 'qnb.smi.error.RetrieveTiaQuoteHeader',
        defaultMessage: 'We have been unable to retrieve your quote online'
    },
    RetrieveTiaQuoteMessage: {
        id: 'qnb.smi.error.RetrieveTiaQuoteMessage',
        defaultMessage: 'We have made changes to our website and as a result are unable to retrieve your quote online. '
            + 'One of our customer service advisors will be able to help on <strong>0800 015 0226</strong>. Alternatively, you can '
    },
    SagaHomepage: {
        id: 'qnb.smi.error.SagaHomepage',
        defaultMessage: 'Return to homepage'
    },
    SmiErrorHeader: {
        id: 'qnb.smi.error.SmiErrorHeader',
        defaultMessage: 'Thank you for your interest in Saga Health Insurance.'
    },
    SmiErrorText: {
        id: 'qnb.smi.error.SmiErrorText',
        defaultMessage: 'We are sorry that, as a result of some of the information you have provided, we are unable to complete your online quotation.'
    },
    SomethingGoneWrong: {
        id: 'qnb.smi.error.SomethingGoneWrong',
        defaultMessage: 'Sorry, something\'s gone wrong with our website.'
    },
    SmiFraudulentCardMessageText1: {
        id: 'qnb.smi.error.SmiFraudulentCardMessageText1',
        defaultMessage: 'It looks like we\'ve had a problem taking your payment.'
    },
    SmiFraudulentCardMessageText2: {
        id: 'qnb.smi.error.SmiFraudulentCardMessageText2',
        defaultMessage: 'Please contact us on {phoneNumber} to discuss further.'
    },
    SmiFraudulentCardMessageText3: {
        id: 'qnb.smi.error.SmiFraudulentCardMessageText3',
        defaultMessage: 'Your account will not be charged but it may show as a pending transaction for up to 24 hours.'
    },
});
